// extracted by mini-css-extract-plugin
export var logo = "_m2-2";
export var logoWrapper = "_m2-1";
export var strip = "_m2-0";